@import "@SeemplicityDev/shared/src/design-system/styles/constants.scss";

@mixin entity-logo-clickable {
  cursor: pointer;
  box-shadow: var(--shadow-low);
  border: var(--border-style);
  background-color: var(--entity-logo-bg);
  transition:
    background-color 0.3s ease-in-out,
    border-color 0.3s ease-in-out;
  padding: 5px;
  &:hover {
    box-shadow: var(--shadow-medium);
    border-color: var(--entity-logo-hover-border-color);
  }
}
@mixin entity-logo-clickable-hover-effect {
  &:not(.is-filter-action) {
    &.is-clickable {
      .seem-icon-external-link {
        opacity: 1;
      }
      img.logo {
        opacity: 0;
      }
    }
  }
}
.entity-logo-container {
  display: flex;
  align-items: center;
  width: max-content;
  .entity-logo {
    &:not(.is-filter-action):hover {
      &.is-clickable {
        .seem-icon-external-link {
          opacity: 1;
        }

        img.logo {
          opacity: 0;
        }
      }
    }
  }

  &.with-label {
    .entity-logo {
      margin-right: var(--spacing-2);
    }
  }

  .entity-name {
    @include b2-typography;
    @include ellipsis(100%);
  }
  .entity-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid transparent;
    height: 30px;
    width: 30px;
    flex: 0 0 30px;
    position: relative;
    overflow: hidden;

    &.is-square {
      border-radius: 0;
    }
    .seem-icon {
      font-size: var(--icon-size-l);
    }
    .logo {
      width: var(--icon-size-l);
      height: var(--icon-size-l);
      transition: opacity 0.2s ease-in-out;
    }

    &.is-compact {
      width: var(--icon-size-l);
      height: var(--icon-size-l);
      flex: 0 0 var(--icon-size-l);
    }

    .seem-icon-external-link {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      font-size: var(--icon-size-s);
      transition: opacity 0.2s ease-in-out;
      z-index: 2;
    }
    &.size-s {
      height: 30px;
      width: 30px;
      flex: 0 0 30px;

      .seem-icon {
        font-size: 16px;
      }
      .logo {
        width: 16px;
        height: 16px;
      }
      &.is-compact {
        width: 16px;
        height: 16px;
        flex: 0 0 16px;
      }
    }
    &.size-l {
      height: 58px;
      width: 58px;
      flex: 0 0 58px;

      .seem-icon {
        font-size: 32px;
      }
      .logo {
        width: 32px;
        height: 32px;
      }
      &.is-compact {
        width: 32px;
        height: 32px;
        flex: 0 0 32px;
      }
    }
    &.has-border {
      border: var(--border-style);
      background-color: var(--main-background-color);
      box-shadow: var(--shadow-low);
      &.is-clickable {
        &:hover {
          box-shadow: var(--shadow-medium);
        }
      }
    }

    &.is-clickable {
      @include entity-logo-clickable;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
    }

    + .skeleton-loader-wrap {
      margin-left: 15px;
    }

    &.is-loading {
      border: none;
      box-shadow: none;
    }
  }
}

//handle details pane header has clickable
.sources-breadcrumbs:hover:has(.entity-logo.is-clickable) {
  .entity-logo.is-clickable {
    @include entity-logo-clickable;
    @include entity-logo-clickable-hover-effect;
  }
}

//handle table row has clickable
.table-wrapper .tr:hover:has(.entity-logo:not(.is-filter-action).is-clickable) {
  .entity-logo {
    @include entity-logo-clickable;
    @include entity-logo-clickable-hover-effect;
  }
}
